export const CONTACT_CORE_FIELDS = `
  id
  firstName
  lastName
  email
  phone
  jobTitle
  companyName
  companyID
  status
  source
  referredByContactID
  referredByName
  preferredCommsMethod
  notes
  engagementLevel
  fitScore
  lastInteractionAt
  lastMeaningfulTouchAt
  relationshipScore
  atRisk
  nextFollowUpAt
  createdAt
  updatedAt
  archivedAt
`;